var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangle = function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.93a2.49 2.49 0 0 1 2.148 1.236l.002.004 7.529 13.176a2.485 2.485 0 0 1-2.147 3.725H4.468a2.485 2.485 0 0 1-2.147-3.725L9.851 4.17l.002-.004A2.48 2.48 0 0 1 12 2.929m0 1.199a1.29 1.29 0 0 0-1.11.64L3.363 17.943l-.002.003a1.284 1.284 0 0 0 1.11 1.924h15.06a1.29 1.29 0 0 0 1.11-.642 1.28 1.28 0 0 0 0-1.282l-.001-.003-7.53-13.176-.093-.14a1.28 1.28 0 0 0-1.016-.5"
  })));
};
export default SvgTriangle;